import { render, staticRenderFns } from "./SectionRealtimeCCU.vue?vue&type=template&id=23fdbe94&scoped=true&"
import script from "./SectionRealtimeCCU.vue?vue&type=script&lang=js&"
export * from "./SectionRealtimeCCU.vue?vue&type=script&lang=js&"
import style0 from "./SectionRealtimeCCU.vue?vue&type=style&index=0&id=23fdbe94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fdbe94",
  null
  
)

export default component.exports